import { API_CONFIG } from '../config/api.config';
import { Category } from '../types';
import { apiService } from './api.service';
import { peekApi } from '../prerender/apiCache';

export const categoryService = {
  /** First-render read of the prerendered response (undefined when not prerendered). */
  peekAllCategories: (): Category[] | undefined => peekApi<Category[]>(API_CONFIG.ENDPOINTS.CATEGORIES.LIST),

  async getAllCategories(): Promise<Category[]> {
    const response = await apiService.get<Category[]>(API_CONFIG.ENDPOINTS.CATEGORIES.LIST);
    return response.data ?? [];
  },

  async getCategoryById(id: string): Promise<Category> {
    const response = await apiService.get<Category>(API_CONFIG.ENDPOINTS.CATEGORIES.BY_ID(id));
    return response.data;
  },
};

